import { useTranslation as useTranslationI18Next } from 'react-i18next';

import { TRANSLATION_FILE_RELATIVE_PATH } from '@services/i18nService';
// This tells i18n to use the namespace configured here o retrieve translations for the components
// We are using the i18next instance of the parent application!
// When your library is used inside a parent, then the parent must have configured the backend path to use content_cdn_url/media
// Configure this according your path pattern defined in content CDN.
// Take into account that the base URL to get translations configured in the application should be the CDN_URL/media
// Use this hook in your components so you don't need to define the ns for each of them
export const useTranslation = () => {
  return useTranslationI18Next(TRANSLATION_FILE_RELATIVE_PATH);
};
